var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-layout"},[_c('md-toolbar',{staticClass:"md-transparent",attrs:{"md-elevation":"0"}},[_c('h1',{staticClass:"md-title",staticStyle:{"flex":"1"}},[_vm._v(_vm._s(_vm.$t('notifications.title')))])]),_c('div',{staticClass:"md-layout-item"},[_vm._v(" Work in progress ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }